import React from 'react';
import ThirdPartyField from './ThirdPartyField';
import InnerTargetField from '../InnerTargetField';


const TargetFieldDataForThirdParty = ({ fieldName, readOnly = false }) => {
  return (
    <>
      <ThirdPartyField fieldName={fieldName} readOnly={readOnly}/>
      <InnerTargetField fieldName={fieldName} readOnly={readOnly}/>
    </>
  );
};

export default TargetFieldDataForThirdParty;